import { formatCurrency } from 'components/Widget/shared/currency';
import { SUMMARY_COPY } from './constants';
import { formatMonths } from './emergencyFund';
import type { EmergencyFundResult, FundGoalKey } from './types';

interface EmergencyFundCalculatorSummaryProps {
  result: EmergencyFundResult;
  goalKey: FundGoalKey;
}

export const EmergencyFundCalculatorSummary = ({ result, goalKey }: EmergencyFundCalculatorSummaryProps) => {
  const { goal, monthsToGoal } = result;
  const alreadyFunded = monthsToGoal === 0;

  return (
    <div className="flex flex-col gap-2 text-center text-heading-sm">
      <p>{SUMMARY_COPY.goal(formatCurrency(goal), formatMonths(goalKey))}</p>
      {monthsToGoal !== null && (
        <p className={alreadyFunded ? 'font-bold' : undefined}>
          {alreadyFunded ? SUMMARY_COPY.alreadyFunded(goalKey) : SUMMARY_COPY.pace(formatMonths(monthsToGoal))}
        </p>
      )}
    </div>
  );
};
